export enum BestDescribesYouEnum {
  FIRST_TIME_BUYER = "First time buyer",
  UPSIZER_OR_DOWNSIZER = "Upsizer / Downsizer",
  INVESTOR = "Investor",
}
